function setEqualHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  elements.forEach(el => {
    el.style.height = 'auto';
    if (el.offsetHeight > maxHeight) {
      maxHeight = el.offsetHeight;
    }
  });

  elements.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    setEqualHeights('.grid-carousel-item .product-name'); 
  }, 100);
});


window.addEventListener('resize', () => {
  setEqualHeights('.grid-carousel-item .product-name');
});
